module.exports = __webpack_public_path__ + "img/safe-area-desktop.bd3b5da1.png";